import styled from "@emotion/styled";
import { colorGuide } from "../../theme/colors";
import { getColor } from "../../theme/theme";
import { generateTextStyles } from "../../utils";

export const SearchWrapper = styled.div<{
  isFocused: boolean;
  hasValue: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 448px;
  min-height: 37px;
  padding: 8px 12px;
  border-radius: 12px;
  gap: 10px;
  border: 0.5px solid ${getColor("border.default.default")};
  position: relative;
  cursor: text;
  box-sizing: border-box;
`;

export const SearchFieldLabel = styled.label`
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  line-height: normal;
  left: 38px;
  right: 38px;
  overflow: hidden;
  min-width: 0;
`;

export const SearchInputField = styled.input`
  position: relative;
  z-index: 1;
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;
  margin: 0;
  padding: 0;
  background: transparent;
  ${generateTextStyles({
    type: "body",
    fontWeight: "regular",
    variant: 3,
    color: colorGuide.lightComponents.searchInput.color,
  })}

  &:focus {
    outline: none;
  }

  ::placeholder {
    ${generateTextStyles({
      type: "body",
      fontWeight: "regular",
      variant: 3,
      color: colorGuide.lightComponents.searchInput.color,
    })}
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
`;

export const ClearIconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
